<template>
  <div id="daily-reports-push">
    <div class="fitler-form">
      <ElForm class="elementui-common-form-styles" v-highlight @submit.native.prevent label-width="50" inline>
        <ElFormItem>
          <el-input v-model="queryForm.keyword" placeholder="请输入报表任务名称或ID" style="width: 220px" @keyup.enter.native="queryAction">
            <i slot="append" @click="queryAction" class="el-icon-search"></i>
          </el-input>
        </ElFormItem>

        <ElFormItem label="报表模板">
          <el-select v-model="queryForm.type" @change="queryAction" clearable placeholder="全部" style="width: 110px">
            <el-option v-for="item in DailyReports.REPORTS_TEMPLATE_TYPES_LIST" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="新建人">
          <el-select v-model="queryForm.opId" @change="queryAction" filterable clearable placeholder="全部" style="width: 110px">
            <el-option v-for="item in PTOM_USERS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <el-button type="primary" @click="gotoAddForm">新建报表任务</el-button>
        </ElFormItem>
      </ElForm>
    </div>

    <Viewport v-model="dailyPushGridOptions.height">
      <vxe-grid v-bind="dailyPushGridOptions">
        <!-- 任务开关列 -->
        <template #switch="{ row }">
          <i-switch @on-change="onTaskStateChange(row)" v-model="row.stateSwitch" />
        </template>

        <!-- 操作列 -->
        <template #operation="{ row }">
          <el-button type="text" @click="modifyRow(row)">编辑</el-button>
          <el-button type="text" @click="showTaskRecords(row)">发送记录</el-button>
          <el-button type="text" @click="removeRow(row)">删除</el-button>
        </template>
      </vxe-grid>

      <div class="pager">
        <el-pagination
          :total="pager.total"
          :current-page.sync="pager.pageIndex"
          :page-size.sync="pager.pageSize"
          :page-sizes="[10, 20, 30, 40, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="search"
          @size-change="queryAction"
          class="pager"
          background
        />
      </div>
    </Viewport>
  </div>
</template>
<script>
import DailyReports from './data/daily.class.js'
import { isArray } from '@/common/js/utils.js'

import { getDailyPushTaskList, updateDailyReportTaskStatusById } from '@/api/report.model'
import { initPageData, PTOM_USERS } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([PTOM_USERS])
const STATES = {
  pause: 0,
  active: 1,
  delete: -1
}
export default {
  name: 'daily-list',
  data() {
    return {
      weekRangedddd: [],
      dailyPushGridOptions: DailyReports.getDailyPushGridOptions(),
      queryForm: {
        keyword: '',
        type: '',
        opId: ''
      },
      pager: {
        pageIndex: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    DailyReports() {
      return DailyReports
    }
  },
  activated() {
    this.search()
  },
  methods: {
    /**
     * @description: 通过表格上面的查询表单触发的查询页码归1
     */
    queryAction() {
      this.pager.pageIndex = 1
      this.search()
    },
    /**
     * @description: 查询任务列表
     */
    search() {
      const { total, ...pager } = this.pager
      getDailyPushTaskList({ ...pager, ...this.queryForm }).then((data) => {
        const { list, page_info } = data
        if (isArray(list)) {
          this.dailyPushGridOptions.data = list.map((item) => ({ ...item, stateSwitch: !!item.taskStatus }))
          this.pager.total = page_info.total_number
        }
      })
    },
    /**
     * @description: 切换任务状态、删除任务
     * @param {*} row
     */
    onTaskStateChange(row, flag) {
      // 开启的状态：1 关闭的状态：0
      let taskStatus = Number(row.stateSwitch)

      // 删除的状态：-1
      if (flag) {
        taskStatus = -1
      }

      return new Promise((resolve, reject) => {
        updateDailyReportTaskStatusById({ id: row.id, taskStatus }).then((data) => {
          if (data) {
            console.log('taskStatus output: ', taskStatus)
            if ([STATES.pause, STATES.active].includes(taskStatus)) {
              const msg = ['关闭', '开启'][taskStatus]
              this.$Message.success(`${msg}成功`)
            }

            if (taskStatus === STATES.delete) {
              this.$Message.success('删除成功')
            }
            resolve()
          }
        })
      })
    },
    /**
     * @description: 跳转到新建报表任务表单页面
     */
    gotoAddForm() {
      this.$router.push({ name: 'daily-form' })
    },
    /**
     * @description:  查看任务发送记录
     */
    showTaskRecords(row) {
      this.$router.push({ name: 'daily-task-records', query: { taskId: row.id || 0 } })
    },
    /**
     * @description: 编辑任务
     */
    modifyRow(row) {
      this.$router.push({ name: 'daily-form', query: { taskId: row.id } })
    },
    /**
     * @description: 删除任务
     */
    removeRow(row) {
      this.$Modal.confirm({
        title: '确认',
        content: `删除任务：${row.reportName}？`,
        onOk: async () => {
          await this.onTaskStateChange(row, 'remove')
          this.search()
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#daily-reports-push {
  .pager {
    text-align: right;
    padding: 5px 0;
  }
}
</style>
